import React from "react";
import { Stack, useMediaQuery } from '@mui/material';
import BlogAuthorAvatar from "./BlogPersonAvatar";
import { colours } from "../../constants/colourConstants";
import { mediaQueries } from "../../constants/mediaQueries";

const BlogArticleDetails = ({ imageUrl, authorName, publishDate, timeToRead }) => {
    const isSmall = useMediaQuery(mediaQueries.isMobile)

    return (
        <Stack
            direction="row"
            spacing={3}
            alignItems="center"
            sx={{
                color: colours.primary.greys[500],
                fontSize: "14px",
            }}
        >
            <BlogAuthorAvatar
                imageUrl={imageUrl}
                authorName={authorName}
            />
            {publishDate && (
                <div>{publishDate}</div>
            )}
            {(timeToRead && !isSmall) && (
                <div>{timeToRead}</div>
            )}
        </Stack>
    )
}

export default BlogArticleDetails